module.exports = __webpack_public_path__ + "img/grune-logo.0369148a.svg";